module.exports = __webpack_public_path__ + "assets/img/B.9498dcd4.jpg";